<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-ums__memberbalancecharge">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item v-if="visible">
          <el-select v-model="dataForm.orgId" placeholder="请选择区域">
            <el-option label="全选" value="" key=""></el-option>
            <el-option
                    v-for="item in orgList"
                    :key="item.id"
                    :label="item.orgName"
                    :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input v-model="dataForm.mobileNumber" placeholder="会员电话" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="dataForm.memberName" placeholder="会员姓名" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.balanceType" placeholder="优果类型">
            <el-option
                    v-for="item in balanceTypes"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.operatType" placeholder="操作类型">
            <el-option
                    v-for="item in operatTypes"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <template>
            <div class="block">
              <el-date-picker
                      v-model="dataForm.beginDate"
                      type="date"
                      :clearable="true"
                      format="yyyy年MM月dd日"
                      value-format="yyyy-MM-dd 00:00:00"
                      placeholder="开始时间">
              </el-date-picker>
            </div>
          </template>
        </el-form-item>
        <el-form-item>
          <template>
            <div class="block">
              <el-date-picker
                      v-model="dataForm.endDate"
                      type="date"
                      :clearable="true"
                      format="yyyy年MM月dd日"
                      :editable="false"
                      value-format="yyyy-MM-dd 00:00:00"
                      placeholder="结束时间">
              </el-date-picker>
            </div>
          </template>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="arcExportHandle()">{{ $t('export') }}</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border
                @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <!--        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>-->
        <el-table-column prop="orgName" label="所属区域" header-align="center" align="center"></el-table-column>
        <el-table-column prop="memberName" label="会员姓名" header-align="center" align="center"></el-table-column>
        <el-table-column prop="mobileNumber" label="会员电话号" header-align="center"
                         align="center"></el-table-column>
        <el-table-column prop="changeNumber" label="改变数值" header-align="center"
                         align="center"></el-table-column>
       <el-table-column prop="balanceType" label="账户类型" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.balanceType===1" type="success">现金</el-tag>
            <el-tag v-else-if="scope.row.balanceType===2 && scope.row.integrationAccountType===1"
                    type="success">设备优果
            </el-tag>
            <el-tag v-else-if="scope.row.balanceType===2 && scope.row.integrationAccountType!=1"
                    type="success">赠送优果
            </el-tag>
            <el-tag v-else-if="scope.row.balanceType===3" type="success">乾坤袋</el-tag>
            <el-tag v-else-if="scope.row.balanceType===4" type="success">祝福袋</el-tag>
            <el-tag v-else-if="scope.row.balanceType===5" type="success">设备优果</el-tag>
            <el-tag v-else-if="scope.row.balanceType===6" type="success">红优果</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="operatType" label="操作类型" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.operatType===0" type="success" size="small">分享直推收益</el-tag>
            <el-tag v-else-if="scope.row.operatType===1" type="success" size="small">分享间推收益</el-tag>
            <el-tag v-else-if="scope.row.operatType===2" type="success" size="small">合伙人分享收益</el-tag>
            <el-tag v-else-if="scope.row.operatType===3" type="success" size="small">合伙人区域每月服务费收益</el-tag>
            <el-tag v-else-if="scope.row.operatType===4" type="success" size="small">合伙人区域奖金</el-tag>
            <el-tag v-else-if="scope.row.operatType===5" type="success" size="small">合伙人个人市场奖金</el-tag>
            <el-tag v-else-if="scope.row.operatType===6" type="success" size="small">合伙人区域优果返利</el-tag>
            <el-tag v-else-if="scope.row.operatType===7" type="success" size="small">市场合伙人优果收益抽成</el-tag>
            <el-tag v-else-if="scope.row.operatType===8" type="success" size="small">商品购买花费现金</el-tag>
            <el-tag v-else-if="scope.row.operatType===9" type="success" size="small">商品购买花费优果</el-tag>
            <el-tag v-else-if="scope.row.operatType===10&&scope.row.integrationAccountType===0"
                    type="success" size="small">赠送优果转账
            </el-tag>
            <el-tag v-else-if="scope.row.operatType===10&&scope.row.integrationAccountType===1"
                    type="success" size="small">设备优果转账
            </el-tag>
            <el-tag v-else-if="scope.row.operatType===11" type="success" size="small">卖家售卖优果</el-tag>
            <el-tag v-else-if="scope.row.operatType===12" type="success" size="small">取消售卖</el-tag>
            <el-tag v-else-if="scope.row.operatType===13" type="success" size="small">寄售申诉通过</el-tag>
            <el-tag v-else-if="scope.row.operatType===14" type="success" size="small">寄售平台拒绝</el-tag>
            <el-tag v-else-if="scope.row.operatType===15" type="success" size="small">买家购买优果</el-tag>
            <el-tag v-else-if="scope.row.operatType===16" type="success" size="small">买家支付超时</el-tag>
            <el-tag v-else-if="scope.row.operatType===17" type="success" size="small">设备续费</el-tag>
            <el-tag v-else-if="scope.row.operatType===18" type="success" size="small">签到加优果</el-tag>
            <el-tag v-else-if="scope.row.operatType===22" type="success" size="small">兑换奖品</el-tag>
            <el-tag v-else-if="scope.row.operatType===23" type="success" size="small">清空设备优果</el-tag>
            <el-tag v-else-if="scope.row.operatType===19&&scope.row.integrationAccountType===0"
                    type="success" size="small">系统操作赠送优果
            </el-tag>
            <el-tag v-else-if="scope.row.operatType===19&&scope.row.integrationAccountType===1"
                    type="success" size="small">系统操作存在优果
            </el-tag>
            <el-tag v-else-if="scope.row.operatType===19&&scope.row.balanceType===6"
                    type="success" size="small">系统操作红果
            </el-tag>
            <el-tag v-else-if="scope.row.operatType===20" type="success" size="small">提现失败返回</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="changeType" label="改变类型" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.changeType===1" type="success">增加</el-tag>
            <el-tag v-else-if="scope.row.changeType===2" type="success">减少</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="srcMemberName" label="来源用户" header-align="center"
                         align="center"></el-table-column>
        <el-table-column prop="createDate" label="创建时间" header-align="center" align="center"></el-table-column>
      </el-table>
      <el-pagination
              :current-page="page"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="limit"
              :total="total"
              layout="total, sizes, prev, pager, next, jumper"
              @size-change="pageSizeChangeHandle"
              @current-change="pageCurrentChangeHandle">
      </el-pagination>
    </div>
  </el-card>
</template>

<script>
  import mixinViewModule from '@/mixins/view-module'
  import qs from "qs";
  import Cookies from "js-cookie";

  export default {
    mixins: [mixinViewModule],
    data() {
      return {
        visible: false,
        orgList: [],
        mixinViewModuleOptions: {
          getDataListURL: '/ums/memberbalancecharge/page',
          getDataListIsPage: true,
          exportURL: '/ums/arcBalancecharge/export',
          deleteURL: '/ums/memberbalancecharge',
          deleteIsBatch: true,
          activatedIsNeed: false
        },
        balanceTypes: [
          {
            value: '',
            label: ''
          }, {
            value: '2',
            label: '赠送优果'
          }, {
            value: '5',
            label: '设备优果'
          }, {
            value: '6',
            label: '红果'
          }
        ],
        operatTypes: [{
          value: '',
          label: ''
        }, {
          value: '9',
          label: '商品购买花费优果'
        }, {
          value: '10',
          label: '优果转账'
        }, {
          value: '0',
          label: '分享直推收益'
        }, {
          value: '1',
          label: '分享间推收益'
        }, {
          value: '2',
          label: '合伙人分享收益'
        }, {
          value: '6',
          label: '合伙人区域优果返利'
        }, {
          value: '7',
          label: '市场合伙人优果收益抽成'
        }, {
          value: '13',
          label: '寄售申诉通过'
        }, {
          value: '15',
          label: '买家购买优果'
        }, {
          value: '14',
          label: '寄售平台拒绝'
        }, {
          value: '18',
          label: '签到加优果'
        }, {
          value: '19',
          label: '系统操作'
        }, {
          value: '23',
          label: '清空设备优果'
        }, {
          value: '22',
          label: '兑换奖品'
        }, {
          value: '24',
          label: '设备续费返利'
        }],
        dataForm:
                {
                  mobileNumber: '',
                  balanceType: '',
                  defaultBalanceType: '2,5,6',
                  operatType:
                          '',
                  beginDate:
                          "",
                  endDate:
                          "",
                  memberName:
                          "",
                  orgId: '',
                  orgName:'',
                  isHead:false
                }
      }
    },
    created() {
      let d = new Date
      d.setDate(d.getDate()-1);
      //d.setTime(d.getTime()-24*30*60*60*1000);
      d.setHours(0);
      d.setMinutes(0);
      d.setSeconds(0);
      d.setMilliseconds(0)
      this.dataForm.beginDate=d
    },
    mounted() {
      const that = this;
      that.getInfo();
    },
    methods: {
      getInfo() {
        this.$http.get(`/sys/user/info`).then(({data: res}) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.dataForm.orgId=res.data.orgId
          this.dataForm.orgName=res.data.orgName
          this.dataForm.isHead=res.data.isHead;
          if (this.dataForm.isHead) {
            this.visible=true;
            this.getOrgList();
          }
        }).catch(() => {
        })
      },
      // 获取部门列表
      getOrgList() {
        return this.$http.get('/sys/org/select').then(({data: res}) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.orgList = res.data
        }).catch(() => {
        })
      },
      // 导出
      arcExportHandle () {
        var memberName=this.dataForm.memberName;
        var mobile=this.dataForm.mobileNumber;
        if(memberName=='' && mobile=='') {
          return this.$message.error("会员电话或者会员姓名至少输入一项")
        }
        var params = qs.stringify({
          'token': Cookies.get('token'),
          ...this.dataForm
        })
        window.location.href = `${window.SITE_CONFIG['apiURL']}${this.mixinViewModuleOptions.exportURL}?${params}`
      }
    }
  }
</script>
